export default function About() {
  const highlights = [
    {
      icon: 'ri-plant-line',
      title: 'Manufacturer of Sojat Henna Powder',
      description: 'Direct from the source'
    },
    {
      icon: 'ri-calendar-line',
      title: 'Established in 2010',
      description: '14+ years of experience'
    },
    {
      icon: 'ri-award-line',
      title: 'MSME Certified Business',
      description: 'Government recognized'
    },
    {
      icon: 'ri-global-line',
      title: 'Bulk Supply & Export Support',
      description: 'Worldwide delivery'
    },
    {
      icon: 'ri-user-heart-line',
      title: 'Trusted by Mehndi Artists & Resellers',
      description: 'Quality you can rely on'
    }
  ];

  return (
    <section id="about" className="py-20 bg-gradient-to-b from-white to-green-50">
      <div className="container mx-auto px-4 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-gray-900 mb-4">
            About Pavitra Rishta
          </h2>
          <div className="w-24 h-1 bg-orange-500 mx-auto mb-8"></div>
        </div>

        <div className="grid lg:grid-cols-2 gap-12 items-center mb-16">
          {/* Image */}
          <div className="relative">
            <div className="w-full h-96 rounded-2xl overflow-hidden shadow-2xl">
              <img
                src="https://readdy.ai/api/search-image?query=Traditional%20henna%20powder%20manufacturing%20process%20in%20Sojat%20Rajasthan%20India%2C%20workers%20processing%20fresh%20green%20henna%20leaves%20in%20clean%20hygienic%20facility%2C%20natural%20sunlight%2C%20authentic%20Indian%20mehendi%20production%2C%20cultural%20heritage%2C%20quality%20control%20process%2C%20traditional%20methods%20meet%20modern%20standards%2C%20clean%20white%20workspace&width=800&height=600&seq=about1&orientation=landscape"
                alt="About Pavitra Rishta"
                className="w-full h-full object-cover"
              />
            </div>
            <div className="absolute -bottom-6 -right-6 w-48 h-48 bg-orange-500/10 rounded-2xl -z-10"></div>
          </div>

          {/* Content */}
          <div>
            <p className="text-base md:text-lg text-gray-700 leading-relaxed mb-6">
              Pavitra Rishta is a trusted manufacturer and bulk supplier of premium quality henna powder made from fresh Sojat henna leaves. We specialize in producing finely filtered natural henna powder for hair care and mehndi application.
            </p>
            <p className="text-base md:text-lg text-gray-700 leading-relaxed mb-6">
              Our products are widely used by wholesalers, distributors, salons, mehndi artists, and online sellers across India and export markets.
            </p>
            <p className="text-base md:text-lg text-gray-700 leading-relaxed">
              With strict quality control, hygienic packaging, and consistent supply, Pavitra Rishta delivers reliable henna powder directly from the manufacturer.
            </p>
          </div>
        </div>

        {/* Highlights */}
        <div className="grid md:grid-cols-2 lg:grid-cols-5 gap-6">
          {highlights.map((item, index) => (
            <div
              key={index}
              className="bg-white rounded-xl p-6 shadow-lg hover:shadow-xl transition-all transform hover:-translate-y-2 text-center"
            >
              <div className="w-16 h-16 bg-gradient-to-br from-green-500 to-green-600 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className={`${item.icon} text-3xl text-white`}></i>
              </div>
              <h3 className="text-sm font-bold text-gray-900 mb-2">{item.title}</h3>
              <p className="text-xs text-gray-600">{item.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}